"use strict";

import { lcvReportsConstants } from "../_constants/lcvReports.constants";

export const INITIAL_LCV_REPORTS_STATE = {
     dealerPage: { dealers: [], totalCount: 0 },
     dealerExport: [],
     gamePage: { gameCodes: [], totalCount: 0 },
     gameExport: [],
     filterOptions: { areas: [], dealers: [], jobRoles: [] },
};

export function lcvReports(state = INITIAL_LCV_REPORTS_STATE, action) {
     switch (action.type) {
          case lcvReportsConstants.LCV_REPORTS_GET_DEALERS_COMPLETE:
               return {
                    ...state,
                    dealerPage: action.payload,
               };
          // The download component writes the file the moment this list turns non empty, so it is
          // emptied again straight after. Otherwise the next download of the same rows never fires.
          case lcvReportsConstants.LCV_REPORTS_GET_DEALERS_EXPORT_COMPLETE:
               return {
                    ...state,
                    dealerExport: action.payload?.dealers || [],
               };
          case lcvReportsConstants.LCV_REPORTS_CLEAR_DEALERS_EXPORT:
               return {
                    ...state,
                    dealerExport: [],
               };
          case lcvReportsConstants.LCV_REPORTS_GET_GAMES_COMPLETE:
               return {
                    ...state,
                    gamePage: action.payload,
               };
          case lcvReportsConstants.LCV_REPORTS_GET_GAMES_EXPORT_COMPLETE:
               return {
                    ...state,
                    gameExport: action.payload?.gameCodes || [],
               };
          case lcvReportsConstants.LCV_REPORTS_CLEAR_GAMES_EXPORT:
               return {
                    ...state,
                    gameExport: [],
               };
          case lcvReportsConstants.LCV_REPORTS_GET_FILTER_OPTIONS_COMPLETE:
               return {
                    ...state,
                    filterOptions: action.payload,
               };
          default:
               return state;
     }
}
